import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showNotificationError } from 'Shared/helpers';

import { updateItem } from 'Shared/actions/todos';
import { destroyMeetingItemAttachment } from 'Shared/api/MeetingItemAttachments.api';

import { WorkspaceItem } from 'Shared/constants/types';

import AttachmentsContainer, { OPTIONS_VIEW_TYPE } from 'Shared/components/Attachments/AttachmentsContainer';

type Props = {
  workspaceItem: WorkspaceItem;
  preview?: boolean;
  view?: OPTIONS_VIEW_TYPE;
};

const WorkspaceItemAttachments = ({ workspaceItem, preview = true, view = 'grid' }: Props) => {
  const dispatch = useDispatch();
  const { itemType, uuid, showPreview, attachments } = workspaceItem;

  const handleToggleAttachmentPreviewClick = useCallback(
    () => dispatch(updateItem(uuid, { itemType, showPreview: !showPreview })),
    [dispatch, uuid, itemType, showPreview]
  );

  const handleRemoveAttachmentClick = useCallback(
    attachmentId => {
      destroyMeetingItemAttachment(attachmentId)
        .then(response => {
          const { id } = response.data.metting_item_attachment;
          dispatch({
            type: 'MEETING_ITEM_REMOVE_ATTACHMENT_RESPONSE',
            meetingItemType: itemType,
            payload: { uuid, attachmentId: id },
          });
        })
        .catch(e => {
          showNotificationError(e);
        });
    },
    [uuid, dispatch, itemType]
  );

  const enablePreview = !preview ? false : showPreview;

  return (
    <AttachmentsContainer
      attachments={attachments}
      options={{ showPreview: enablePreview, view }}
      handleDeleteAttachment={handleRemoveAttachmentClick}
      handleUpdateShowPreview={preview && handleToggleAttachmentPreviewClick}
    />
  );
};

export default WorkspaceItemAttachments;
